export const MOCK_POINTER_CLICK_MS = 200;

export function sleep(ms: number, cancelled: () => boolean) {
  return new Promise<void>((resolve) => {
    window.setTimeout(() => {
      if (!cancelled()) resolve();
    }, ms);
  });
}

/** Brief scale-down + optional ring via CSS class on the pointer. */
export async function mockPointerClick(
  setClicking: (clicking: boolean) => void,
  cancelled: () => boolean,
  durationMs = MOCK_POINTER_CLICK_MS
) {
  if (cancelled()) return;
  setClicking(true);
  await sleep(durationMs, cancelled);
  if (!cancelled()) setClicking(false);
}
